import { logBoostListingBundle } from "../logging/helpers/commonLoggingFunctions";
import { PackageButtonProps } from "../models/PropsInterface";
import "../cssStyles/PackageButton.css";

const PackageButton = (props: PackageButtonProps) => {
  const padding: { [key: string]: string } = {
    left:
      props.language === "en"
        ? "package_button__left_most_package"
        : "package_button__right_most_package",
    mid: "",
    right:
      props.language === "en"
        ? "package_button__right_most_package"
        : "package_button__left_most_package",
  };
  // const isMembership = props.unit.service.includes('membership')
  const isMembership = false;

  const onClickPackageHandler = (name: string) => {
    logBoostListingBundle(props.modelId);
    props.onClick(name);
  };

  return props.unit ? (
    <div
      dir={props.language === "en" ? "ltr" : "rtl"}
      className={`vas-col ${
        props.selectedName === props.name
          ? "package_button__selected_package"
          : ""
      } package_button__package_item ${
        padding[props.padding]
      } package_button__centered `}
    >
      <button
        onClick={() => onClickPackageHandler(props.name)}
        className={`vas content package_button__package_button package_button__content vas-m-0 vas-p-2`}
      >
        <div className={`package_button__display_block`}>
          {!isMembership && (
            <img
              src={props.unit.icon}
              className={`vas package_button__package_item_icon`}
            />
          )}
        </div>
        <div>
          <div className={`package_button__font_size_lg`}>
            {props.unit.appLabel}
          </div>
        </div>
      </button>
    </div>
  ) : (
    <div></div>
  );
};

export default PackageButton;
